import { createContext } from 'react';

/** Success and error are all this portal needs; warnings belong on the page. */
export type ToastSeverity = 'success' | 'error';

export interface ToastOptions {
  message: string;
  /** Defaults to success, which is what most actions report. */
  severity?: ToastSeverity;
}

export interface ToastContextValue {
  /** Shows a message. A second call replaces whatever is on screen. */
  show: (options: ToastOptions) => void;
}

/**
 * Kept in its own file, separate from the provider component.
 *
 * A file that exports both a component and a non-component value breaks Vite's
 * hot reloading, so the split is deliberate rather than tidiness.
 */
export const ToastContext = createContext<ToastContextValue | null>(null);
